import app from "flarum/app";
import removePasswordEdit from "../common/actions/removePasswordEdit";
import addUniLoginFields from "./actions/AddUniLoginFields";
import overwriteLoginFunctionality from "./actions/overwriteLoginFunctionality";
import overwriteLogoutFunctionality from "../common/actions/overwriteLogoutFunctionality";
import UniLoginUser from "../common/models/UniLoginUser";
import addLoginButton from "./actions/addLoginButton";
import handleExpiredSession from "./actions/handleExpiredSession";
import Model from 'flarum/Model';

app.initializers.add('netcompany-auth-unilogin', () => {
  app.store.models.unilogin = UniLoginUser;
  app.store.models.users.prototype.fullname = Model.attribute('fullname');

  handleExpiredSession();
  overwriteLoginFunctionality();
  overwriteLogoutFunctionality();
  removePasswordEdit();
  addUniLoginFields();
  addLoginButton();
});
